
import type { Product } from './types';

export const fosserProducts: Product[] = [
  {
    id: 'p1',
    shopId: '',
    name: 'Fosser Premium LA 5W-30',
    brand: 'Fosser',
    price: 120, // UPDATED PRICE
    image: '/lovable-uploads/daadf9d6-32dc-4632-bdcf-4244ee201953.jpg',
    description: 'High-performance low SAPS engine oil for gasoline and diesel engines.',
    category: 'oil',
  },
  {
    id: 'p8',
    shopId: '',
    name: 'Fosser Premium VS 5W-40',
    brand: 'Fosser',
    price: 120, // UPDATED PRICE
    image: 'https://fosser.de/wp-content/themes/yootheme/cache/17/fosser-premium-vs-5w40-1-17e3b546.webp',
    description: 'Synthetic oil with high wear protection and thermal stability.',
    category: 'oil',
  },
  {
    id: 'dp3',
    shopId: '10',
    name: 'FOSSER Premium LA 5W-30',
    brand: 'Fosser',
    price: 120,
    image: 'https://fosser.de/wp-content/themes/yootheme/cache/ad/fosser-premium-la-5w30-1-ad2306e0.jpeg',
    description: 'High-performance low SAPS engine oil for gasoline and diesel engines.',
    category: 'oil',
  },
  {
    id: 'dp4',
    shopId: '10',
    name: 'FOSSER Premium PSA 5W-30',
    brand: 'Fosser',
    price: 120,
    image: 'https://fosser.de/wp-content/themes/yootheme/cache/c2/fosser-premium-psa-5w30-1-c2087f11.webp',
    description: 'High quality engine oil PSA 5W-30.',
    category: 'oil',
  },
  {
    id: 'dp5',
    shopId: '10',
    name: 'FOSSER Premium GM 5W-20 (Hybrid Approved)',
    brand: 'Fosser',
    price: 150,
    image: 'https://fosser.de/wp-content/themes/yootheme/cache/8f/fosser-premium-gm-5w20-1-8f57a5a3.webp',
    description: 'GM 5W-20 engine oil for hybrid vehicles.',
    category: 'oil',
  },
  {
    id: 'dp6',
    shopId: '10',
    name: 'FOSSER Premium VS 5W-40',
    brand: 'Fosser',
    price: 120,
    image: 'https://fosser.de/wp-content/themes/yootheme/cache/17/fosser-premium-vs-5w40-1-17e3b546.webp',
    description: 'Synthetic oil with high wear protection and thermal stability.',
    category: 'oil',
  },
  {
    id: 'dp7',
    shopId: '10',
    name: 'FOSSER Premium Multi Longlife 5W-30',
    brand: 'Fosser',
    price: 140,
    image: 'https://fosser.de/wp-content/themes/yootheme/cache/f5/fosser-premium-multi-longlife-5w30-f5750302.webp',
    description: 'Longlife, high-performance multi-grade engine oil.',
    category: 'oil',
  },
  {
    id: 'dp8',
    shopId: '10',
    name: 'FOSSER Drive TS 10W-40',
    brand: 'Fosser',
    price: 100,
    image: 'https://fosser.de/wp-content/themes/yootheme/cache/d7/fosser-drive-ts-10w40-1-d7f25f4b.webp',
    description: '10W-40 high performance engine oil for modern engines.',
    category: 'oil',
  },
  {
    id: 'dp9',
    shopId: '10',
    name: 'FOSSER Drive Turbo 10W-40',
    brand: 'Fosser',
    price: 120,
    image: 'https://fosser.de/wp-content/themes/yootheme/cache/22/fosser-drive-turbo-10w40-2276d4d5.webp',
    description: 'Turbocharged engine oil formula.',
    category: 'oil',
  },
  {
    id: 'dp10',
    shopId: '10',
    name: 'FOSSER Antifreeze FA 12',
    brand: 'Fosser',
    price: 50,
    image: 'https://fosser.de/wp-content/themes/yootheme/cache/89/fosser-fa12-1-8988f814.webp',
    description: 'High-grade FA 12 antifreeze for cooling systems.',
    category: 'antifreeze',
  },
  {
    id: 'dp11',
    shopId: '10',
    name: 'FOSSER Antifreeze FA 11 Yellow, Blue, Green',
    brand: 'Fosser',
    price: 50,
    image: 'https://fosser.de/wp-content/themes/yootheme/cache/dc/Antifreeze-dcc2778c.webp',
    description: 'Multi-type colored antifreeze coolant.',
    category: 'antifreeze',
  },
  {
    id: 'dp12',
    shopId: '10',
    name: 'FOSSER Race 4T 10W 40',
    brand: 'Fosser',
    price: 50,
    image: 'https://fosser.de/wp-content/themes/yootheme/cache/e5/fosser-race-4t-10w40-1l-e523ac05.webp',
    description: 'Motorcycle-specific synthetic oil.',
    category: 'oil',
  },
  {
    id: 'dp13',
    shopId: '10',
    name: 'FOSSER Brake Fluid DOT 4',
    brand: 'Fosser',
    price: 25,
    image: 'https://fosser.de/wp-content/themes/yootheme/cache/61/fosser-brakefluid-dot4-1-6150de8b.webp',
    description: 'DOT 4 brake fluid for optimal braking performance.',
    category: 'brake fluid',
  },
  {
    id: 'dp14',
    shopId: '10',
    name: 'FOSSER MZ 80W-90 GL 5',
    brand: 'Fosser',
    price: 120, // UPDATED
    image: 'https://fosser.de/wp-content/themes/yootheme/cache/d5/fosser-mz-80w90-gl5-1-d509a1e4.webp',
    description: 'Powerful gear oil for vehicles.',
    category: 'gear oil',
  },
  {
    id: 'dp15',
    shopId: '10',
    name: 'FOSSER ATF MB 17',
    brand: 'Fosser',
    price: 50, // UPDATED
    image: 'https://fosser.de/wp-content/themes/yootheme/cache/99/fosser-atf-mb17-1l-99256b45.webp',
    description: 'Automatic Transmission Fluid.',
    category: 'atf',
  },
  {
    id: 'dp16',
    shopId: '10',
    name: 'FOSSER ZHF',
    brand: 'Fosser',
    price: 50, // UPDATED
    image: 'https://fosser.de/wp-content/themes/yootheme/cache/02/fosser-zhf-1l-0230cbf0.webp',
    description: 'Multi-purpose hydraulic fluid.',
    category: 'hydraulic fluid',
  },
  {
    id: 'dp17',
    shopId: '10',
    name: 'FOSSER Syn 75W-90 GL5/GL4',
    brand: 'Fosser',
    price: 140, // UPDATED
    image: 'https://fosser.de/wp-content/themes/yootheme/cache/d8/fosser-syn-75w90-gl5-gl4-d899b84c.webp',
    description: 'Synthetic gear oil 75W-90.',
    category: 'gear oil',
  },
  {
    id: 'dp18',
    shopId: '10',
    name: 'FOSSER Dexron D II',
    brand: 'Fosser',
    price: 120, // UPDATED
    image: 'https://fosser.de/wp-content/themes/yootheme/cache/1e/fosser-dexron-d2-1-1e7346c0.webp',
    description: 'ATF Dexron D II for automatic transmissions.',
    category: 'atf',
  },
];
